import React, { useState } from 'react'
import Modal from '../../components/modal/modal'
import { Grid } from '@material-ui/core'
import { ValidateField, ValidatorTypes } from '../../util/validators'
import DatePickerInput from '../../components/inputs/date-picker'
import Input from '../../components/inputs/new-input'
import TextField from '../../components/inputs/textarea-input'
import _ from 'lodash'
import { PROJECT_STATUS } from '../../util/enums'

export default function ChangeProjectStatus(props) {
  const { open, dialogClose, newStatus, } = props

  const [fields, setFields] = useState({
    dlpMonths: {
      name: 'dlpMonths',
      label: 'Enter DLP Months',
      type: 'text',
      error: false,
      touched: false,
      valid: true,
      value: '',
      validation: [ValidatorTypes.REQUIRED]
    },
    dlpDate: {
      name: 'dlpDate',
      label: 'DLP Date',
      type: 'datepicker',
      error: false,
      touched: false,
      valid: true,
      value: new Date(),
      validation: [ValidatorTypes.REQUIRED]
    },
    reason: {
      name: 'reason',
      label: 'Reason',
      type: 'textarea',
      error: false,
      touched: false,
      valid: true,
      value: '',
      validation: [ValidatorTypes.REQUIRED, ValidatorTypes.TEXTAREA]
    }
  })

  const inputChangeHandler = ({ value, name }) => {
    let _fields = _.cloneDeep(fields)
    _fields[name].value = value
    _fields[name].touched = true
    const { error, valid } = ValidateField({ value, validation: _fields[name].validation })
    _fields[name].error = error
    _fields[name].valid = valid
    setFields(_fields)
  }

  const submitForm = () => {
    const data = {
      status: newStatus
    }
    let _fields = _.cloneDeep(fields)
    let isFormValid = true
    const fieldsToValidate = newStatus === PROJECT_STATUS.DLP ? ['dlpMonths', 'dlpDate'] : ['reason'];

    for (const key of fieldsToValidate) {
      if (_fields[key]) {
        const { value, validation } = _fields[key];
        const { error, valid } = ValidateField({ value, validation });
        _fields[key].touched = true;
        _fields[key].valid = valid;
        _fields[key].error = error;
        isFormValid = isFormValid && valid;
      }
    }
    if (!isFormValid) {
      setFields(_fields)
    } else {
      if (newStatus === PROJECT_STATUS.DLP) {
        if (_fields.dlpDate.valid) data.dateOfDLP = _fields.dlpDate.value
        if (_fields.dlpMonths.valid) data.dlp_months = _fields.dlpMonths.value
      } else {
        if (_fields.reason.valid) data.reasonOfLost = _fields.reason.value
      }

      setFields(prev => ({
        ...prev,
        reason: { ...prev.reason, value: '' },
        dlpMonths: { ...prev.dlpMonths, value: '' },
        dlpDate: { ...prev.dlpDate, value: '' }
      }))
      props.changeStatus(data)
    }
  }

  return (
    <Modal
      open={open}
      onClose={dialogClose}
      fullWidth={true}
      maxWidth='sm'
      modalHeading='Change Project Status'
      modalSaveTxt='Save'
      modalCloseTxt='Cancel'
      onClick={() => submitForm()}
      showActionBtn
      savebtnClass='createBtn'
      cxlbtnClass='cancelBtn'
      primary
    >
      <>
        {newStatus === PROJECT_STATUS.DLP
          ?
          <>
            <Grid container>
              <Grid xs={3} item><p>Enter DLP Months</p></Grid>
              <Grid xs={6} item>
                <Input
                  {...fields.dlpMonths}
                  onChange={(e) => inputChangeHandler({ value: e.target.value, name: fields.dlpMonths.name })}
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={3} item><p>DLP Date</p></Grid>
              <Grid xs={6} item>
                <DatePickerInput
                  {...fields.dlpDate}
                  onChange={(e) => inputChangeHandler({ value: e, name: fields.dlpDate.name })}
                />
              </Grid>
            </Grid>
          </>
          :
          <Grid container className="subtaskrow-1">
            <Grid xs={3} item><p>Reason</p></Grid>
            <Grid xs={9} item className="reasonField">
              <TextField
                {...fields.reason}
                onChange={(e) => inputChangeHandler({ value: e.target.value, name: fields.reason.name })}
              />
            </Grid>
          </Grid>}
      </>
    </Modal>
  )
}
